import { Injectable } from '@angular/core';
import { Globals } from '../globals';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AuthHttpService } from "./auth-http.service";
import { CreateDialogComponent } from "../shared/dialogs/create-dialog/create-dialog.component";
import { HttpResponse} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AvatarService {

  public user_avatar_num:number;
  public error_data:string;
  public prev_user_avatar:number;
  avatar_changed = false;

  constructor(
		public dialog: MatDialog,
    public Globals:Globals,
    private http:AuthHttpService
  ) { }

	getAvatar(){
		//получим измененный аватар и отобразим вместо текущего через индикатор загрузки
    let id:string;
    if(Boolean(this.Globals.user)){
      id = this.Globals.user.users_id

      let params: any = {
        'id': id
      };
      this.prev_user_avatar = Number(this.Globals.user.avatar_image);
      this.Globals.user.avatar_image = 'loading';
      this.user_avatar_num = 5;
        this.http.post('/api/user/user-avatar', params).subscribe((res:HttpResponse<any>) => {
          this.Globals.user.avatar_image = res.body;
          if(Boolean(this.Globals.user.avatar_image)){
            this.user_avatar_num = Number(this.Globals.user.avatar_image);
          }else{
            this.user_avatar_num = 5;
          }

        },(error)=>{
          if (error.status !== 401 && error.status !== 503 && error.status !== 403 && error.status !== 423 && this.Globals.error) {
            this.Globals.error = false;
            this.dialog.open(CreateDialogComponent, <MatDialogConfig>{
                data: {
                  text: this.error_data,
                  icon_class:"dialog-icon-warning"
                }
            });
          }
      });
      return this.Globals.user.avatar_image;
    }else{
      return false;
    }
	}

}
